import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
// import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
// import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";
// import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

// import Edit from "../assets/icons/editar.svg";

import "../private-app/dashboard/dashboard.scss";

interface UserListInterface {
  loading?: boolean,
  error?: boolean,
  users?: any,
  search?: any,
};

const UserList: React.FC<UserListInterface> = ({ loading, users, search }) => {
  const [searchInput, setSearchInput] = useState("");

  return (
    <>
      <div className="user-list-container">
        <div className="user-list-search">
          <div className="user-list-search-item">
            <button className="global-white-btn">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14 10H10V14H4V10H0V4H4V0H10V4H14V10Z" fill="white" />
              </svg>
              Criar novo usuário
            </button>
          </div>
          <div className="user-list-search-item">
            <input
              type="text"
              placeholder="Pesquisar"
              className="search-input"
              name="search"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="search-btn" onClick={() => search(searchInput)}>
              {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
        </div>
        <div className="list-container">
          <div className="list">
            <div className="list-header">
              <label>Nome</label>
              <label>Email</label>
              <label>Empresa</label>
              <label>CNPJ</label>
              <label>Status</label>
              <label>Edit</label>
            </div>

            {users &&
              users.length > 0 &&
              users.map((user: any, index: number) => (
                <div className="list-body" key={index}>
                  <span className="list-item">{user.name}</span>
                  <span className="list-item">{user.email}</span>
                  <span className="list-item">
                    {user.company && user.company.name}
                  </span>
                  <span className="list-item">
                    {user.company && user.company.cnpj}
                  </span>
                  <span
                    className={
                      "list-item " + (user.isAuthorised ? "green" : "red")
                    }
                  >
                    {user.isAuthorised ? "Ativo" : "Desativado"}
                  </span>
                  <span className="list-item">
                    <a href={`editar-comprador/${user.id}`}>
                      <svg
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.8 7.2L23.4 6C22.6 5.3 21.5 5.4 20.8 6.1L7.1 19.5C7 19.6 6.8 19.8 6.8 20L5.5 24.9C5.4 25.3 5.7 25.6 6.1 25.5L10.9 24.2C11.1 24.1 11.3 24 11.4 23.9L25 10C25.7 9.2 25.7 8 24.8 7.2ZM6.7 24.4L7.6 21L10 23.5L6.7 24.4ZM10.9 23L8 20L18 10.3L20.7 13L10.9 23ZM21.5 12.2L18.8 9.5L19.5 8.8L22.2 11.5L21.5 12.2ZM24.2 9.3L23 10.6L20.4 8L21.5 6.9C21.8 6.6 22.3 6.6 22.7 6.9L24.2 8.2C24.6 8.4 24.6 9 24.2 9.3ZM10 20.2C9.8 20.4 9.8 20.8 10 21.1C10.2 21.3 10.6 21.3 10.9 21.1L18.7 13.3C18.9 13.1 18.9 12.7 18.7 12.4C18.5 12.2 18.1 12.2 17.8 12.4L10 20.2ZM31 22.2C31 27.1 27.1 31.1 22.1 31.1H8.9C4 31.1 0 27.2 0 22.2V8.9C0 4 3.9 0 8.9 0H22.2C27 0 31 3.9 31 8.9V22.2Z"
                          fill="#4B4B4B"
                        />
                      </svg>
                    </a>
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default UserList;